"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTimeFormat = void 0;
const convertTimeFormat = (time) => {
    // Split the input time string into hours and minutes
    const [hours, minutes] = time.split(":").map(Number);
    // Determine the period (AM/PM)
    const period = hours >= 12 ? "PM" : "AM";
    // Convert the hours to 12-hour format
    const hours12 = hours % 12 || 12;
    // Construct the new time string
    return `${hours12}:${minutes.toString().padStart(2, "0")} ${period}`;
};
exports.convertTimeFormat = convertTimeFormat;
